import ICommand from "./ICommand";
import useMessageLogic from "../logic/useMessageLogic";
import {selectSystemName} from "../redux/system";
import {useAppSelector} from "../hooks";

export const useHostnameCommand = (): ICommand => {
  const messages = useMessageLogic()
  const systemName = useAppSelector(selectSystemName)

  return {
    help(): string {
      return '- hostname\t\t\t\t:: shows the system name';
    },

    async process(msg: string): Promise<void> {
      messages.addNoticeMessage(`you are the '${systemName}' system`)
    },

    matches(msg: string): boolean {
      return ['hostname'].includes(msg.toLowerCase().trim())
    }
  };
}